
export default {
  props: {
    selectedCollection: {
      required: false,
      type: Object,
    },
  },
};
